// Curated library of INLINE SVG glyphs that admins may drop into editable content blocks via the
// `[[icon:NAME]]` token (expanded at render by expandIcons.ts). Only inline glyphs belong here — never
// `/img/...` map/photo assets. The token is plain text, so it survives the server-side HTML sanitizer
// (which strips raw <svg>); the actual markup comes from THIS registry (admins supply only the name),
// so there's no XSS exposure. Add an entry here when migrating a glyph-bearing section, then reference
// it as `[[icon:its-name]]` in the block.
//
// Keep each SVG presentation-only (no scripts/handlers); inherit color via `currentColor` from the
// surrounding CSS. The set is Winter War-flavoured: tabletop gaming + midwinter.
export const contentIcons: Record<string, string> = {
  // Right-pointing arrow for editorial CTAs ("Register now →", "Submit a game →").
  'arrow-right':
    '<svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
  // A six-sided die — organized play / open gaming.
  dice:
    '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18"/>' +
    '<circle cx="8.5" cy="8.5" r="1.4"/><circle cx="15.5" cy="8.5" r="1.4"/>' +
    '<circle cx="8.5" cy="15.5" r="1.4"/><circle cx="15.5" cy="15.5" r="1.4"/>' +
    '<circle cx="12" cy="12" r="1.4"/></svg>',
  // Snowflake — the Winter War signature glyph.
  snowflake:
    '<svg viewBox="0 0 24 24"><line x1="12" y1="2" x2="12" y2="22"/>' +
    '<line x1="3.3" y1="7" x2="20.7" y2="17"/><line x1="3.3" y1="17" x2="20.7" y2="7"/>' +
    '<polyline points="9 4 12 7 15 4"/><polyline points="9 20 12 17 15 20"/>' +
    '<polyline points="4.5 11 7.5 12 4.5 13"/><polyline points="19.5 11 16.5 12 19.5 13"/></svg>',
  // Map pin — venue / directions.
  'map-pin':
    '<svg viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>' +
    '<circle cx="12" cy="10" r="3"/></svg>',
  // Fanned cards — collectible card games.
  cards:
    '<svg viewBox="0 0 24 24"><rect x="4" y="5" width="11" height="15" rx="1"/>' +
    '<path d="M15 7l4.2 1.5-4.8 13.2-3.4-1.2"/></svg>',
  // Shield — miniatures / wargaming.
  shield:
    '<svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
}

/** Sorted icon names, for the inline editor's "Insert icon" picker. */
export function iconNames(): string[] {
  return Object.keys(contentIcons).sort()
}
